import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { EmissionsChartDesktop } from "../EmissionsChartDesktop/EmissionsChartDesktop";
import { EmissionsChartMobile } from "../EmissionsChartMobile/EmissionsChartMobile";
import { InfoItemProps } from "../Info/Info";

export const EmissionsChart: React.FC = () => {
  const { t } = useTranslation("tour");
  const labels = t("EmissionsChart") as Translations;
  const isDesktop = useMediaQuery({ query: bp.m });

  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <EmissionsChartDesktop labels={labels} /> : <EmissionsChartMobile labels={labels} />}
    </ChartContainer>
  );
};
